import { render, staticRenderFns } from "./DocumentApproval.vue?vue&type=template&id=11a642d8&"
import script from "./DocumentApproval.vue?vue&type=script&lang=js&"
export * from "./DocumentApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports